import { render, staticRenderFns } from "./ConsultaCiotDetalhes.vue?vue&type=template&id=01b4553a"
import script from "./ConsultaCiotDetalhes.vue?vue&type=script&lang=js"
export * from "./ConsultaCiotDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports